export const statusFilterStyles = {
	container: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: { xs: 'stretch', sm: 'flex-start' },
		gap: 1,
		flex: { xs: '0 0 auto', sm: '0 1 auto' },
		width: { xs: '100%', sm: 'auto' }
	},

	root: {
		flex: '0 0 auto',
		width: { xs: '100%', sm: 'fit-content' },
		minWidth: { xs: 0, sm: 275 },
		maxWidth: { xs: '100%', sm: 415 }
	},

	select: {
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#1212124D'
		}
	},

	chipContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 0.5
	},

	chipIcon: {
		height: 16,
		width: 16,
		fill: 'none'
	},

	textValue: {
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		lineHeight: '24px',
		color: 'text.fadedPrimary'
	},

	placeholder: {
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		lineHeight: '24px',
		color: 'text.secondary'
	},

	menuList: {
		display: 'flex',
		flexDirection: 'column',
		padding: 0
	},

	filterSkeleton: {
		flex: { xs: '0 0 auto', sm: '0 1 auto' },
		width: { xs: '100%', sm: 'fit-content' },
		minWidth: { xs: 0, sm: 275 },
		maxWidth: { xs: '100%', sm: 440 },
		height: 40
	},

	menuItem: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 1,
		width: '100%',
		minWidth: 0,
		minHeight: 'auto',
		padding: '8px 16px'
	},

	menuItemCount: {
		color: 'text.secondary',
		fontSize: '1rem',
		whiteSpace: 'nowrap',
		flexShrink: 0
	}
};
